module.exports = __webpack_public_path__ + "img/Estonia.c03f7185.png";